export const REQUIRED_MESSAGE = 'This field is required'
export const ONE_OF_MESSAGE = 'Must be one of the following'
export const MORE_THAN_ZERO_MESSAGE = 'Must be greater than 0'
